import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DetailPage } from '../detail/detail';

@IonicPage()
@Component({
  selector: 'page-ambient',
  templateUrl: 'ambient.html',
})
export class AmbientPage {

  data: Observable<any>;
  index: number;

  constructor(public navCtrl: NavController, public navParams: NavParams, public menuCtrl: MenuController, public global: GlobalProvider, public http: HttpClient) {
    this.menuCtrl.enable(true, 'myMenu');
  }

  ionViewDidLoad() {
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/nome_tela';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', this.global.banco);
      body.append('menu', this.global.menu);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        this.global.nome_tela = [];
        for (let i = 0; i < data.nome_tela.split(';').length; i++) {
          this.global.nome_tela[i] = data.nome_tela.split(';')[i];
        }
      });
    }
    catch (e) {
      console.error(e);
    }

    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/nome_tabela';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', this.global.banco);
      body.append('jwt', this.global.token);
      body.append('menu', this.global.menu);
      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
      this.global.nome_tabela = [];
      for (let i = 0; i < data.tabelas.split(';').length; i++) {
        this.global.nome_tabela[i] = data.tabelas.split(';')[i];
      }
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  open_tela(tela) {
    this.index = 0;
    for (let i = 0; i < this.global.nome_tela.length; i++) {
      if (tela == this.global.nome_tela[i]) {
        this.index = i;
      }
    }

    this.global.table = this.global.nome_tabela[this.index];
    this.global.page_title = tela;
    this.navCtrl.push(DetailPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/ambient/ambient.ts